import React from "react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

export const SiteLayout = ({ children, headerVariant = "minimal" }) => (
  <div className="min-h-screen bg-background text-foreground flex flex-col">
    <Header variant={headerVariant} />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);
